import type { BisBlockData, BisBlockKind, BisDraftBasis, BisSnapshotItem, BisVersionLevel } from '@raro/domain';
import type { BisAsset } from './assets';

/** Um bloco como a API devolve na cópia de trabalho. */
export type BisItem = BisSnapshotItem & { kind: BisBlockKind; data: BisBlockData; status: 'proposed' | 'active'; generatedBy: 'human' | 'ai' | 'rule'; basis: string | null; held: boolean; wasPublished: boolean; state: 'proposed' | 'new' | 'changed' | 'held' | 'published' };
export type BisData = {
  id: string | null; version: number; publishedAt: string | null;
  /** o rótulo da versão em vigor ("1.0.2"); a próxima, pela regra, com o porquê (`bisVersionLevel`) */
  versionLabel: string | null; next: { level: BisVersionLevel; why: string; label: string } | null;
  draft: { status: 'none' | 'pending' | 'ready' | 'failed'; error: string | null; basis: BisDraftBasis | null; at: string | null };
  items: BisItem[]; removed: BisSnapshotItem[];
  pending: { added: number; changed: number; removed: number; total: number; proposed: number; held: number };
  versions: { number: number; label: string | null; level: BisVersionLevel | null; note: string; changes: { added: number; changed: number; removed: number }; publishedAt: string; by: string | null; items: number }[];
  stale: string[];
  /** os arquivos citados nos blocos, pelo id do ativo */
  assets: Record<string, BisAsset>;
  live: { competitors: number; evidence: number; decisions: number; learnings: number } | null;
  canEdit: boolean; canPublish: boolean;
};
export const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;
export const BIS_STATE_LABELS = { proposed: 'proposta da Machine', new: 'novo, ainda não publicado', changed: 'alterado, ainda não publicado', held: 'rascunho, fica fora da próxima versão', published: '' } as const;

/** o número da versão em vigor como a tela mostra: o rótulo por tamanho, ou o inteiro antes da renumeração */
export const bisV = (d: { version: number; versionLabel: string | null }) => d.versionLabel ?? String(d.version);

